import { Avatar, Button } from '@mui/material'
import React, { useState } from 'react'
import "./TweetBox.css"
import { collection, addDoc, serverTimestamp } from "firebase/firestore"; 
import db, { auth } from "../../firebase"

const TweetBox = () => {
  
  const [tweetMessage, setTweetMessage] = useState("");
  const [tweetImage, setTweetImage] = useState("");

  const sendTweet = (e) => {
    // firebaseのデータベースに保存処理を書く
    e.preventDefault();
    const { uid, photoURL, displayName } = auth.currentUser;
    
    addDoc(collection(db, "posts"),{
      displayName: displayName,
      verified: true,
      text: tweetMessage,
      avatar: photoURL,
      image: tweetImage,
      timestamp: serverTimestamp()
    });

    setTweetMessage("");
    setTweetImage("");
  }

  return (
    <div className='tweet_box'>
        <form>
          <div className='tweet_box_input'>
            <Avatar />
            <input
            value={tweetMessage}
            placeholder='今どうしてる？'
            type='text'
            onChange={(e) => setTweetMessage(e.target.value)}
            >
            </input>
          </div>
            <input 
            value={tweetImage}
            className='tweet_box_img' 
            placeholder='画像のURL' 
            type='text'
            onChange={(e) => setTweetImage(e.target.value)}
            ></input>
            <Button 
            className='tweet_box_btn' 
            type='submit'
            onClick={sendTweet}
            >ツイートする</Button>

        </form>
    </div>
  )
}

export default TweetBox